export default __webpack_public_path__ + "static/media/wwr-img.03094abd.webp";